import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import style from "./Opportunities.module.css";
import Switch from "react-switch";
import { MdVisibility, MdShare, MdBusinessCenter, MdLocationOn, MdArticle } from "react-icons/md";
import { BiSearch } from "react-icons/bi";
import { baseurl } from '../Url'
import { useNavigate, useOutletContext } from "react-router-dom";
import ApplyButton from "./ApplyButtton";
import Loader from "../Loder/Loader";
import { MdMoreVert } from "react-icons/md";
import { MdWarningAmber } from "react-icons/md";

const PAGE_SIZE = 15;
const DESCRIPTION_PREVIEW_MAX = 110;
const SORT_OPTIONS = [
  { value: "High Relevance", label: "High Relevance" },
  { value: "Recently Published", label: "Recently Published" },
  { value: "Validity", label: "Validity" },
];
const OPPORTUNITY_TYPE_OPTIONS = [
  { value: "", label: "All" },
  { value: "job", label: "Job" },
  { value: "study", label: "Study" },
];
const VALID_TYPE_FILTERS = new Set(["job", "study"]);

const Opportunities = () => {
  const { onMenuToggle } = useOutletContext() || {};
  const [isOpenToOpportunities, setIsOpenToOpportunities] = useState(true);
  const [vacancies, setVacancies] = useState([])
  const [isLoading, setIsLoading] = useState(true)
  const [errorMessage, setErrorMessage] = useState('')
  const [appliedVacancies, setAppliedVacancies] = useState(new Set())
  const [page, setPage] = useState(1);
  const [searchInput, setSearchInput] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [categoryFilter, setCategoryFilter] = useState("");
  const [typeFilter, setTypeFilter] = useState("");
  const [categoryOptions, setCategoryOptions] = useState([{ value: "", label: "All" }]);
  const [sortBy, setSortBy] = useState("High Relevance");
  const [categoryMenuOpen, setCategoryMenuOpen] = useState(false);
  const categoryMenuRef = useRef(null);
  const [typeMenuOpen, setTypeMenuOpen] = useState(false);
  const typeMenuRef = useRef(null);
  const [sortMenuOpen, setSortMenuOpen] = useState(false);
  const sortMenuRef = useRef(null);
  const [totalCount, setTotalCount] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [applyingVacancy, setApplyingVacancy] = useState(null)
  const [showAlreadyAppliedModal, setShowAlreadyAppliedModal] = useState(false)
  const [showSuccessModal, setShowSuccessModal] = useState(false)
  const [showErrorModal, setShowErrorModal] = useState(false)
  const [modalMessage, setModalMessage] = useState('')
  const [shareCopiedId, setShareCopiedId] = useState(null)
  const [copySnackbarOpen, setCopySnackbarOpen] = useState(false)
  const [profileGuardPopup, setProfileGuardPopup] = useState({
    open: false,
    message: "",
  })
  const Navigate = useNavigate()
  const vacanciesFetchIdRef = useRef(0)

  const getAuthBearerToken = () => {
    const token = localStorage.getItem("access-token");
    if (!token) return "";
    if (typeof token === "string" && token.startsWith("{")) {
      try {
        const parsed = JSON.parse(token);
        return parsed?.token ?? parsed ?? token;
      } catch {
        return token;
      }
    }
    return token;
  };

  const isProfileCompletedForApply = async (memberId) => {
    const orgId = localStorage.getItem("ORGID");
    if (!memberId || !orgId) return false;

    const bearer = getAuthBearerToken();
    const response = await fetch(`${baseurl}/banner/data/retrive`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...(bearer ? { Authorization: `Bearer ${bearer}` } : {}),
      },
      body: JSON.stringify({
        user_id: memberId,
        org_id: orgId,
      }),
    });

    const data = await response.json();
    const completion = Number(data?.data?.profile_completion ?? 0);
    return Number.isFinite(completion) && completion >= 100;
  };

  const ensureProfileCompletionBeforeApply = async () => {
    const memberId = localStorage.getItem("USERID");
    if (!memberId) return;

    try {
      const isComplete = await isProfileCompletedForApply(memberId);
      if (isComplete) return;

      setProfileGuardPopup({
        open: true,
        message: "Please complete your profile before applying for this job.",
      });
      throw new Error("PROFILE_INCOMPLETE");
    } catch (error) {
      if (error?.message === "PROFILE_INCOMPLETE") {
        throw error;
      }
      setProfileGuardPopup({
        open: true,
        message: "We could not verify your profile completion. Please update your profile before applying.",
      });
      throw new Error("PROFILE_CHECK_FAILED");
    }
  };
  const handleToggleChange = (checked) => {
    setIsOpenToOpportunities(checked);
  };

  const formatDate = (dateString) => {
    if (!dateString || dateString === "-") return "-";
    const date = new Date(dateString);
    if (isNaN(date)) return dateString;
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };

  const getNormalizedOpportunityType = (row) => {
    const possibleTypeValues = [
      row?.type,
      row?.opportunity_type,
      row?.opportunityType,
      row?.category_name,
      row?.categoryName,
    ];
    const hasStudyKeyword = possibleTypeValues.some((value) => String(value ?? "").toLowerCase().includes("study"));
    if (hasStudyKeyword) return "study";

    // Study records often ship course fields even when type is missing.
    if (
      String(row?.course_title ?? row?.courseTitle ?? "").trim() ||
      String(row?.course_description ?? row?.courseDescription ?? "").trim()
    ) {
      return "study";
    }
    return "job";
  };

  const isStudyOpportunity = (row) => getNormalizedOpportunityType(row) === "study";

  /** Single headline for compact list (LinkedIn-style): role or course name only. */
  const getOpportunityPrimaryTitle = (row) => {
    if (isStudyOpportunity(row)) {
      const t = String(
        row.course_title ?? row.courseTitle ?? row.job_title ?? row.name ?? ""
      ).trim();
      const programType = String(row.program_type ?? row.programType ?? "").trim();
      if (!t && !programType) return "-";
      if (t && programType) return `${t} · ${programType}`;
      return t || programType;
    }
    return String(row.job_title ?? row.name ?? "").trim() || "-";
  };

  /** Second line: company (jobs) or college + university (study). */
  const getOpportunityOrgLine = (row) => {
    if (isStudyOpportunity(row)) {
      const college = String(row.college_name ?? row.collegeName ?? "").trim();
      const uni = String(row.university ?? "").trim();
      const parts = [college, uni].filter(Boolean);
      if (parts.length) return parts.join(" · ");
      const dept = String(row.department ?? "").trim();
      return dept || "—";
    }
    const org = String(
      row.organization_name ??
        row.organizationName ??
        row.company_name ??
        row.companyName ??
        ""
    ).trim();
    if (org) {
      if (org.toLowerCase() === "duno") return "duno club";
      return org;
    }
    const designation = String(row.designation ?? "").trim();
    if (designation) return designation;
    const emp = String(row.employment_mode ?? row.employmentMode ?? "").trim();
    return emp || "—";
  };

  /** Third line: location and work/study mode. */
  const getOpportunityLocationModeLine = (row) => {
    const loc = String(row.work_location ?? row.workLocation ?? "").trim();
    const mode = isStudyOpportunity(row)
      ? String(row.study_mode ?? row.studyMode ?? row.work_mode ?? row.workMode ?? "").trim()
      : String(row.work_mode ?? row.workMode ?? "").trim();
    if (mode && loc) return `${mode} - ${loc}`;
    if (mode) return mode;
    if (loc) return loc;
    return "";
  };

  const stripHtmlToPlain = (html) => {
    if (html == null) return "";
    return String(html)
      .replace(/<[^>]*>/g, " ")
      .replace(/\s+/g, " ")
      .trim();
  };

  const getOpportunityDescriptionDisplay = (row) => {
    if (isStudyOpportunity(row)) {
      const courseDesc = String(
        row.course_description ?? row.courseDescription ?? ""
      ).trim();
      if (courseDesc) return courseDesc;
    }
    const jobDesc = row.job_description || row.description;
    return jobDesc != null && String(jobDesc).trim() !== "" ? String(jobDesc) : "-";
  };

  const truncateDescriptionPreview = (plain) => {
    const full = String(plain ?? "").trim();
    if (!full || full === "-") return "";
    if (full.length <= DESCRIPTION_PREVIEW_MAX) return full;
    const cut = full.slice(0, DESCRIPTION_PREVIEW_MAX).trimEnd();
    const lastSpace = cut.lastIndexOf(" ");
    const base = lastSpace > 40 ? cut.slice(0, lastSpace) : cut;
    return `${base}...`;
  };
  const getOpportunityTypeLabel = (row) => (getNormalizedOpportunityType(row) === "study" ? "Study" : "Job");

  const isVacancyExpired = (dateString) => {
    if (!dateString || dateString === "-") return false;
    const expiryDate = new Date(dateString);
    if (Number.isNaN(expiryDate.getTime())) return false;
    expiryDate.setHours(23, 59, 59, 999);
    return Date.now() > expiryDate.getTime();
  };

  const isVacancyEndingSoon = (dateString) => {
    if (!dateString || dateString === "-") return false;
    const expiryDate = new Date(dateString);
    if (Number.isNaN(expiryDate.getTime())) return false;
    expiryDate.setHours(23, 59, 59, 999);
    const diffMs = expiryDate.getTime() - Date.now();
    if (diffMs < 0) return false;
    const twoDaysMs = 2 * 24 * 60 * 60 * 1000;
    return diffMs <= twoDaysMs;
  };

  const getStatusColor = (status) => {
    if (!status) return "#8C8C8C";
    switch (status.toLowerCase()) {
      case "expired":
        return "#EF4444";
      case "ending soon":
        return "#F59E0B";
      case "active":
        return "#00DFC7";
      case "pending":
        return "#FFBE00";
      case "available":
        return "#0151CD";
      default:
        return "#8C8C8C";
    }
  };

  const getDisplayStatus = (vacancy) => {
    const expired = isVacancyExpired(vacancy?.valid_upto || vacancy?.validUpto);
    if (expired) return "Expired";
    const endingSoon = isVacancyEndingSoon(vacancy?.valid_upto || vacancy?.validUpto);
    if (endingSoon) return "Ending soon";
    return vacancy?.status || "Available";
  };

  useEffect(() => {
    const t = setTimeout(() => setDebouncedSearch(searchInput.trim()), 400);
    return () => clearTimeout(t);
  }, [searchInput]);

  // Reset to page 1 when search changes. useLayoutEffect so `page` is 1 before the
  // fetch effect runs in the same commit (avoids requesting stale page>1 then overwriting page 1).
  useLayoutEffect(() => {
    setPage(1);
  }, [debouncedSearch]);

  useEffect(() => {
    const onClickOutside = (event) => {
      if (categoryMenuRef.current && !categoryMenuRef.current.contains(event.target)) {
        setCategoryMenuOpen(false);
      }
      if (typeMenuRef.current && !typeMenuRef.current.contains(event.target)) {
        setTypeMenuOpen(false);
      }
      if (sortMenuRef.current && !sortMenuRef.current.contains(event.target)) {
        setSortMenuOpen(false);
      }
    };
    document.addEventListener("mousedown", onClickOutside);
    document.addEventListener("touchstart", onClickOutside);
    return () => {
      document.removeEventListener("mousedown", onClickOutside);
      document.removeEventListener("touchstart", onClickOutside);
    };
  }, []);

  useEffect(() => {
    const orgId = localStorage.getItem("ORGID");
    if (!orgId) {
      setCategoryOptions([{ value: "", label: "All" }]);
      return;
    }

    let cancelled = false;

    const fetchCategoryOptions = async () => {
      try {
        const params = new URLSearchParams({ org_id: orgId });
        const response = await fetch(`${baseurl}/opportunity/category/list?${params.toString()}`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
          cache: "no-store",
        });

        const data = await response.json();
        if (cancelled) return;

        if (data.status === "success" && Array.isArray(data.data)) {
          const dynamicOptions = data.data
            .filter((item) => {
              const categoryName = item?.category_name;
              return typeof categoryName === "string" && categoryName.trim().length > 0 && item?.id;
            })
            .map((item) => {
              const categoryName = item.category_name.trim();
              return {
                value: String(item.id),
                label: categoryName,
                categoryName,
              };
            });

          const seen = new Set();
          const uniqueOptions = dynamicOptions.filter((option) => {
            if (seen.has(option.label)) return false;
            seen.add(option.label);
            return true;
          });

          setCategoryOptions([{ value: "", label: "All" }, ...uniqueOptions]);
        } else {
          setCategoryOptions([{ value: "", label: "All" }]);
        }
      } catch (error) {
        if (cancelled) return;
        console.error("Error fetching opportunity categories:", error);
        setCategoryOptions([{ value: "", label: "All" }]);
      }
    };

    fetchCategoryOptions();

    return () => {
      cancelled = true;
    };
  }, []);

  useEffect(() => {
    const fetchId = ++vacanciesFetchIdRef.current;

    const run = async () => {
      setIsLoading(true);
      setErrorMessage("");

      const memberId = localStorage.getItem("USERID");
      if (!memberId) {
        if (fetchId !== vacanciesFetchIdRef.current) return;
        setErrorMessage("Please login to view vacancies");
        setVacancies([]);
        setTotalCount(0);
        setTotalPages(0);
        setIsLoading(false);
        return;
      }

      try {
        const params = new URLSearchParams({
          member_id: memberId,
          page: String(page),
          limit: String(PAGE_SIZE),
        });
        if (debouncedSearch) params.set("search", debouncedSearch);
        if (categoryFilter) {
          params.set("category_id", categoryFilter);
        }
        const normalizedTypeFilter = String(typeFilter || "").toLowerCase().trim();
        if (VALID_TYPE_FILTERS.has(normalizedTypeFilter)) {
          // Send explicit Job/Study filter in vacancies list API.
          params.set("type", normalizedTypeFilter);
          params.set("opportunity_type", normalizedTypeFilter);
        }
        if (sortBy) params.set("sort_by", sortBy);

        const response = await fetch(`${baseurl}/vacancies/list?${params.toString()}`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
          cache: "no-store",
        });

        const data = await response.json();
        if (fetchId !== vacanciesFetchIdRef.current) return;

        if (data.status === "success") {
          const list = Array.isArray(data.data) ? data.data : [];
          const filteredByType = VALID_TYPE_FILTERS.has(normalizedTypeFilter)
            ? list.filter((item) => getNormalizedOpportunityType(item) === normalizedTypeFilter)
            : list;
          // Open postings first, expired last; then unapplied before applied (stable within each bucket).
          const sorted = [...filteredByType].sort((a, b) => {
            const aExpired = isVacancyExpired(a.valid_upto || a.validUpto) ? 1 : 0;
            const bExpired = isVacancyExpired(b.valid_upto || b.validUpto) ? 1 : 0;
            if (aExpired !== bExpired) return aExpired - bExpired;
            const aApplied = a.has_applied ? 1 : 0;
            const bApplied = b.has_applied ? 1 : 0;
            if (aApplied !== bApplied) return aApplied - bApplied;
            return 0;
          });
          setVacancies(sorted);
          const total =
            typeof data.total === "number" && !Number.isNaN(data.total) && !VALID_TYPE_FILTERS.has(normalizedTypeFilter)
              ? data.total
              : filteredByType.length;
          setTotalCount(total);
          const pages =
            typeof data.total_pages === "number" && !Number.isNaN(data.total_pages) && !VALID_TYPE_FILTERS.has(normalizedTypeFilter)
              ? data.total_pages
              : total > 0
                ? Math.ceil(total / PAGE_SIZE)
                : 0;
          setTotalPages(pages);

          const appliedSet = new Set();
          filteredByType.forEach((v) => {
            if (v.has_applied) appliedSet.add(v.id);
          });
          setAppliedVacancies(appliedSet);
        } else {
          setErrorMessage(data.message || "Failed to load vacancies");
          setVacancies([]);
          setTotalCount(0);
          setTotalPages(0);
        }
      } catch (error) {
        if (fetchId !== vacanciesFetchIdRef.current) return;
        console.error("Error fetching vacancies:", error);
        setErrorMessage("An error occurred while loading vacancies");
        setVacancies([]);
        setTotalCount(0);
        setTotalPages(0);
      } finally {
        if (fetchId === vacanciesFetchIdRef.current) setIsLoading(false);
      }
    };

    run();
  }, [page, debouncedSearch, categoryFilter, typeFilter, sortBy]);

  const handleApply = async (vacancyId) => {
    const memberId = localStorage.getItem('USERID')

    if (!memberId) {
      setModalMessage('Please login to apply for this vacancy')
      setShowErrorModal(true)
      return
    }

    if (appliedVacancies.has(vacancyId)) {
      setShowAlreadyAppliedModal(true)
      return
    }

    setApplyingVacancy(vacancyId)

    try {
      const response = await fetch(`${baseurl}/vacancies/apply`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          vacancy_id: vacancyId,
          member_id: memberId
        })
      })

      const data = await response.json()

      if (data.status === 'success') {
        setAppliedVacancies(prev => new Set([...prev, vacancyId]))
        setShowSuccessModal(true)
      } else {
        setModalMessage(data.message || 'Failed to submit application')
        setShowErrorModal(true)
      }
    } catch (error) {
      console.error('Error applying to vacancy:', error)
      setModalMessage('An error occurred while submitting your application')
      setShowErrorModal(true)
    } finally {
      setApplyingVacancy(null)
    }
  }


  const handleView = (vacancyId) => {
    const vacancy = vacancies.find((item) => item.id === vacancyId);
    if (vacancy && isVacancyExpired(vacancy.valid_upto || vacancy.validUpto)) return;
    Navigate(`/job-view/${vacancyId}`);
  }

  const handleShare = async (row) => {
    if (isVacancyExpired(row.valid_upto || row.validUpto)) return;
    const currentUserId = localStorage.getItem('USERID');
    const userId = row.employer_id || currentUserId || row.id;
    const jobId = row.id;

    // Share backend OG route so WhatsApp can read metadata and thumbnail.
    let shareUrl = `${baseurl}/opportunities/share/${userId}/${jobId}`;

    // If sharer is logged in, generate/reuse a referral link for this JOB asset
    if (currentUserId) {
      try {
        const token = localStorage.getItem("access-token");
        let bearer = token;
        if (token && typeof token === "string" && token.startsWith("{")) {
          try {
            const parsed = JSON.parse(token);
            bearer = parsed?.token ?? parsed ?? token;
          } catch {
            bearer = token;
          }
        }

        const res = await fetch(`${baseurl}/referral/link`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            ...(bearer && { Authorization: `Bearer ${bearer}` }),
          },
          body: JSON.stringify({
            user_id: currentUserId,
            asset_category: "JOB",
            asset_id: jobId,
          }),
        });
        const data = await res.json();
        if (data.status && data.data?.referral_code) {
          shareUrl = `${shareUrl}?ref=${data.data.referral_code}`;

          // Store referral metadata in localStorage for the sharer
          localStorage.setItem("duno_referral_code", data.data.referral_code);
          if (data.data.referrer_user_id) {
            localStorage.setItem("duno_referral_user_id", data.data.referrer_user_id);
          } else if (currentUserId) {
            localStorage.setItem("duno_referral_user_id", currentUserId);
          }
          localStorage.setItem(
            "duno_referral_asset_category",
            data.data.referral_asset_category || "JOB"
          );
          if (data.data.referral_asset_id || jobId) {
            localStorage.setItem(
              "duno_referral_asset_id",
              data.data.referral_asset_id || jobId
            );
          }
        }
      } catch (err) {
        console.warn("Referral link fetch failed for vacancy share:", err);
      }
    }

    navigator.clipboard.writeText(shareUrl).then(() => {
      setShareCopiedId(row.id);
      setCopySnackbarOpen(true);
      setTimeout(() => {
        setShareCopiedId(null);
        setCopySnackbarOpen(false);
      }, 2000);
    });
  }


  return (
    <div className={style.container}>
      <div className={style.pageInner}>
        <div className={style.contentSection}>
        {/* <div className={style.toggleCard}>
          <div className={style.toggleSection}>
            {typeof onMenuToggle === "function" && (
              <button
                type="button"
                className={style.mobileHeaderMenuBtn}
                onClick={onMenuToggle}
                aria-label="Open menu"
              >
                <MdMoreVert size={22} />
              </button>
            )}
            <Switch
              onChange={handleToggleChange}
              checked={isOpenToOpportunities}
              offColor="#94A3B8"
              onColor="#0151CD"
              checkedIcon={false}
              uncheckedIcon={false}
              height={24}
              width={48}
            />
            <p className={style.toggleText}>I am open to new opportunities</p>
          </div>
        </div> */}

        <div className={style.tableSection}>
          <h2 className={style.sectionTitle}>Explore Opportunities</h2>
          <div className={style.listToolbar}>
            <div className={style.searchField}>
              <BiSearch size={20} style={{ color: "#94a3b8", flexShrink: 0 }} aria-hidden />
              <input
                type="search"
                placeholder="Search title, role, location…"
                value={searchInput}
                onChange={(e) => setSearchInput(e.target.value)}
                aria-label="Search opportunities"
              />
            </div>
            <div className={`${style.customSelect} ${style.customSelectCategory}`} ref={categoryMenuRef}>
              <button
                type="button"
                className={style.customSelectTrigger}
                onClick={() => setCategoryMenuOpen((v) => !v)}
                aria-haspopup="listbox"
                aria-expanded={categoryMenuOpen}
                aria-label="Opportunity category"
              >
                <span>{categoryOptions.find((opt) => opt.value === categoryFilter)?.label || "All"}</span>
                <span className={style.customSelectArrow}>▾</span>
              </button>
              {categoryMenuOpen && (
                <div className={style.customSelectMenu} role="listbox">
                  {categoryOptions.map((opt) => (
                    <button
                      key={opt.value || "all"}
                      type="button"
                      className={`${style.customSelectOption} ${categoryFilter === opt.value ? style.customSelectOptionActive : ""}`}
                      onClick={() => {
                        setCategoryFilter(opt.value);
                        setPage(1);
                        setCategoryMenuOpen(false);
                      }}
                    >
                      {opt.label}
                    </button>
                  ))}
                </div>
              )}
            </div>
            <div className={`${style.customSelect} ${style.customSelectType}`} ref={typeMenuRef}>
              <button
                type="button"
                className={style.customSelectTrigger}
                onClick={() => setTypeMenuOpen((v) => !v)}
                aria-haspopup="listbox"
                aria-expanded={typeMenuOpen}
                aria-label="Opportunity type"
              >
                <span>{OPPORTUNITY_TYPE_OPTIONS.find((opt) => opt.value === typeFilter)?.label || "All"}</span>
                <span className={style.customSelectArrow}>▾</span>
              </button>
              {typeMenuOpen && (
                <div className={style.customSelectMenu} role="listbox">
                  {OPPORTUNITY_TYPE_OPTIONS.map((opt) => (
                    <button
                      key={opt.value || "all-types"}
                      type="button"
                      className={`${style.customSelectOption} ${typeFilter === opt.value ? style.customSelectOptionActive : ""}`}
                      onClick={() => {
                        setTypeFilter(opt.value);
                        setPage(1);
                        setTypeMenuOpen(false);
                      }}
                    >
                      {opt.label}
                    </button>
                  ))}
                </div>
              )}
            </div>
            <div className={`${style.customSelect} ${style.customSelectSort}`} ref={sortMenuRef}>
              <button
                type="button"
                className={style.customSelectTrigger}
                onClick={() => setSortMenuOpen((v) => !v)}
                aria-haspopup="listbox"
                aria-expanded={sortMenuOpen}
                aria-label="Sort By"
              >
                <span>{SORT_OPTIONS.find((opt) => opt.value === sortBy)?.label || "High Relevance"}</span>
                <span className={style.customSelectArrow}>▾</span>
              </button>
              {sortMenuOpen && (
                <div className={style.customSelectMenu} role="listbox">
                  {SORT_OPTIONS.map((opt) => (
                    <button
                      key={opt.value}
                      type="button"
                      className={`${style.customSelectOption} ${sortBy === opt.value ? style.customSelectOptionActive : ""}`}
                      onClick={() => {
                        setSortBy(opt.value);
                        setPage(1);
                        setSortMenuOpen(false);
                      }}
                    >
                      {opt.label}
                    </button>
                  ))}
                </div>
              )}
            </div>
          </div>
          <table className={style.opportunitiesTable}>
            <thead>
              <tr>
                <th>Opportunity</th>
                <th>Valid upto</th>
                <th>Status</th>
                <th className={style.actionth}>Action</th>
              </tr>
            </thead>
            <tbody>
              {isLoading ? (
                <tr><td colSpan="4" style={{ padding: '4rem', textAlign: 'center' }}><Loader /></td></tr>
              ) : vacancies.length > 0 ? (
                vacancies.map((row) => {
                  const displayStatus = getDisplayStatus(row);
                  const isExpired = isVacancyExpired(row.valid_upto || row.validUpto);
                  const primaryTitle = getOpportunityPrimaryTitle(row);
                  const orgLine = getOpportunityOrgLine(row);
                  const locModeLine = getOpportunityLocationModeLine(row);
                  const descriptionFull = stripHtmlToPlain(getOpportunityDescriptionDisplay(row));
                  const descriptionPreview = truncateDescriptionPreview(descriptionFull);
                  const opportunityTypeLabel = getOpportunityTypeLabel(row);
                  return (
                  <tr key={row.id}>
                    <td
                      data-label="Opportunity"
                      className={style.titleDescriptionCell}
                    >
                      <div className={style.cardOpportunityTitleRow}>
                        <div className={style.cardOpportunityTitle}>
                          {primaryTitle}
                        </div>
                        <span
                          className={`${style.opportunityTypeBadge} ${opportunityTypeLabel === "Study" ? style.studyBadge : style.jobBadge}`}
                        >
                          {opportunityTypeLabel}
                        </span>
                      </div>
                      <div className={style.cardOpportunityMetaRow}>
                        <MdBusinessCenter className={style.cardMetaIcon} aria-hidden />
                        <span className={style.cardOpportunityOrg}>{orgLine}</span>
                        {locModeLine ? (
                          <>
                            <span className={style.metaVerticalDivider} aria-hidden />
                            <MdLocationOn className={style.cardMetaIcon} aria-hidden />
                            <span className={style.cardOpportunityLocMode}>{locModeLine}</span>
                          </>
                        ) : null}
                      </div>
                      {descriptionPreview ? (
                        <div className={style.cardOpportunityMetaRow}>
                          <MdArticle className={style.cardMetaIcon} aria-hidden />
                          <p className={style.cardOpportunityDescription}>
                            {descriptionPreview}
                          </p>
                        </div>
                      ) : null}
                    </td>
                    <td data-label="Valid upto">{formatDate(row.valid_upto || row.validUpto)}</td>
                    <td data-label="Status">
                      <span
                        className={style.statusBadge}
                        style={{
                          backgroundColor: `${getStatusColor(displayStatus)}18`,
                          color: getStatusColor(displayStatus),
                        }}
                      >
                        {displayStatus}
                      </span>
                    </td>
                    <td data-label="Action">
                      <div className={style.actionCell}>
                        <ApplyButton
                          vacancyId={row.id}
                          initiallyApplied={appliedVacancies.has(row.id)}
                          isExpired={isExpired}
                          onBeforeApply={ensureProfileCompletionBeforeApply}
                          onSuccess={(id) => {
                            setAppliedVacancies(prev => new Set([...prev, id]));
                          }}
                        />
                        <button
                          className={`${style.actionBtn} ${style.shareBtn} ${shareCopiedId === row.id ? style.shareCopied : ''} ${isExpired ? style.expiredBtn : ''}`}
                          onClick={() => handleShare(row)}
                          title={isExpired ? "Expired jobs cannot be shared" : (shareCopiedId === row.id ? "Copied!" : "Share")}
                          disabled={isExpired}
                        >
                          <MdShare className={style.viewIcon} />
                          <span>{shareCopiedId === row.id ? "Copied!" : "Share"}</span>
                        </button>
                        <button
                          className={`${style.actionBtn} ${style.viewBtn} ${isExpired ? style.expiredBtn : ''}`}
                          onClick={() => handleView(row.id)}
                          title={isExpired ? "Expired jobs cannot be viewed" : "View Details"}
                          disabled={isExpired}
                        >
                          <MdVisibility className={style.viewIcon} /> <span>View</span>
                        </button>
                      </div>
                    </td>
                  </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan="4" className={style.emptyState}>
                    <div className={style.emptyStateContent}>
                      <div className={style.emptyStateIcon}>📋</div>
                      <p className={style.emptyStateText}>
                        {errorMessage || "No opportunities found"}
                      </p>
                      <p className={style.emptyStateSubtext}>
                        Check back later for new openings
                      </p>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
          {!isLoading && totalCount > 0 ? (
            <div className={style.paginationBar}>
              <p className={style.paginationMeta}>
                Showing {(page - 1) * PAGE_SIZE + 1}–{Math.min(page * PAGE_SIZE, totalCount)} of{" "}
                {totalCount}
              </p>
              <div className={style.paginationActions}>
                <button
                  type="button"
                  className={style.pageBtn}
                  disabled={page <= 1}
                  onClick={() => setPage((p) => Math.max(1, p - 1))}
                >
                  Previous
                </button>
                <span className={style.pageIndicator}>
                  Page {page}
                  {totalPages > 0 ? ` of ${totalPages}` : ""}
                </span>
                <button
                  type="button"
                  className={style.pageBtn}
                  disabled={totalPages <= 0 || page >= totalPages}
                  onClick={() => setPage((p) => p + 1)}
                >
                  Next
                </button>
              </div>
            </div>
          ) : null}
        </div>
        </div>
      </div>
      {copySnackbarOpen && (
        <div className={style.snackbar}>
          <p>Link copied</p>
        </div>
      )}
      {profileGuardPopup.open && (
        <div className={style.profileGuardOverlay}>
          <div className={style.profileGuardModal}>
            <div className={style.profileGuardHeader}>
              <div className={style.profileGuardIconWrap}>
                <MdWarningAmber className={style.profileGuardIcon} />
              </div>
              <h4>Complete your profile</h4>
            </div>
            <p>{profileGuardPopup.message}</p>
            <div className={style.profileGuardActions}>
              <button
                type="button"
                className={style.profileGuardSecondaryBtn}
                onClick={() => setProfileGuardPopup({ open: false, message: "" })}
              >
                Not now
              </button>
              <button
                type="button"
                className={style.profileGuardPrimaryBtn}
                onClick={() => {
                  setProfileGuardPopup({ open: false, message: "" });
                  Navigate("/profile");
                }}
              >
                Update Profile
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Opportunities;
